import { useMemo } from 'react'
import { CardInfo, getCDNUrl } from '@shared'
import { useNavigate } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import { Button } from '../../../components/Button'
import { GetFreeItem } from '../../../../game/views/shop/getFreeItem'

interface PopupProps {
  onClose: () => void
}

export const RefillPopup = ({ onClose }: PopupProps) => {
  const navigate = useNavigate()

  const { t } = useTranslation()
  const cardInfo = useMemo(() => {
    return {
      url: getCDNUrl("/assets/shop/finger-refill.png"),
      effects: {},
      title: "Out of taps",
      description: "Refill it up with the dispatcher’s options or wait \n (1 tap is refilled in 1 hour)"
    }
  }, [t])


  return (
    <CardInfo
      url={cardInfo.url}
      effects={cardInfo.effects}
      onClose={onClose}
      title={cardInfo.title}
      description={cardInfo.description}
    >
      <Button
        icon="shop"
        onClick={() => {
          navigate('/shop')
          onClose();
        }}
      >
        Go to Dispatcher
      </Button>
      <GetFreeItem small label={t('ad.getFreeItem')} onClick={() => onClose()} />
    </CardInfo>
  )
}
